const FALLBACK_OPEN_URL_ORIGIN = 'https://api.mirai.com';

const getAllowedOpenUrlOrigin = () => {
  try {
    return new URL(process.env.SERVICE_SYNAPSE).origin;
  } catch {
    return FALLBACK_OPEN_URL_ORIGIN;
  }
};

const getAllowedOpenUrlPrefix = () => `${getAllowedOpenUrlOrigin()}/`;

const getAllowedOpenUrl = (value) => {
  const url = typeof value === 'string' ? value.trim() : '';
  if (!url) return undefined;

  try {
    return new URL(url).origin === getAllowedOpenUrlOrigin() ? url : undefined;
  } catch {
    return undefined;
  }
};

const isAllowedOpenUrl = (value) => getAllowedOpenUrl(value) !== undefined;

export {
  FALLBACK_OPEN_URL_ORIGIN,
  getAllowedOpenUrl,
  getAllowedOpenUrlOrigin,
  getAllowedOpenUrlPrefix,
  isAllowedOpenUrl,
};
